<app-modal-generico [modelo]="modalGenerico">
  <article class="row bg-gray">
    <form class="col-12 m-auto form" [formGroup]="formDatos" (ngSubmit)="getRnt()">
      <div class="form-row">
        <div class="form-group col-8">
          <p class="mb-1 font-weight-bold">Ingrese el número de RNT</p>
          <input formControlName="lista_rnt" type="text" class="form-control form-control-sm">
        </div>
        <div class="col-4 form-group text-center">
          <button type="submit" [disabled]="!formDatos.valid" class="btn btn-primary paso-capacidad w-100 mt-4">Buscar</button>
        </div>
      </div>
    </form>
    <ng-container *ngIf="datosRnt.length > 0">
      <p class="col-12 mb-1 font-weight-bold">Establecimientos para suspender</p>
      <div class="col-12 table-responsive">
        <app-tablas [headers]="headers" [paginar]="false">
          <tr *ngFor="let item of datosRnt">
            <td>{{item.codigo_rnt}}</td>
            <td>{{item.razon_social}}</td>
            <td>{{item.descripcion_estado_rnt}}</td>
            <img src="/assets/icons/delete.png" class="pointer ml-2 mt-3" alt="" (click)="onEliminarRnt()" height="25">
          </tr>
        </app-tablas>
      </div>
    </ng-container>
  </article>
  <ng-container *ngIf="datosRnt.length > 0">
    <footer class="text-center p-1">
      <button class="btn btn-primary paso-capacidad" (click)="confirm()">Suspender establecimientos</button>
    </footer>
  </ng-container>
</app-modal-generico>